import uploadToCDNRequest from '@picsart/cloud-storage/api/uploadToCDN';

import { ErrorMessages } from '@/consts/errors';
import { NotificationType } from '@/types';
import { getAccessToken } from '@/utils/user/getAccessToken';
import { showNotification } from '@/utils/ui/showNotification';

const uploadToCDN = async (file: File) => {
  const abortController = new AbortController();
  const accessToken = getAccessToken();

  if (!accessToken) {
    return;
  }

  try {
    const response = await uploadToCDNRequest({
      file,
      accessToken,
      abortController,
    });

    return response.url;
  } catch (error) {
    showNotification({
      title: ErrorMessages.uploadToCDN,
      type: NotificationType.ERROR,
    });
    return null;
  }
};

export { uploadToCDN };
